/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.387 5.3324C8.066 4.7824 8.5 3.9419 8.5 3c0-1.6568-1.3431-3-3-3-1.6568 0-3 1.3432-3 3 0 .9418.434 1.7823 1.113 2.3323C1.5048 6.1023 0 8.1254 0 10.5v3c0 .8284.6716 1.5 1.5 1.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 1-.5-.5v-3C1 8.0147 3.0147 6 5.5 6c1.3156 0 2.4987.564 3.3223 1.4647a.5.5 0 1 0 .738-.6747A5.508 5.508 0 0 0 7.387 5.3324ZM3.5 3c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M11.9098 15.1351a.5.5 0 1 0 .6804.7328l3.3946-3.1521-3.3946-3.1521a.5.5 0 1 0-.6804.7328l2.6054 2.4193-2.6054 2.4193ZM9.8402 10.2965a.5.5 0 0 0-.6804-.7328l-3.3946 3.1521 3.3946 3.1521a.5.5 0 1 0 .6804-.7328l-2.6054-2.4193 2.6054-2.4193Z"
    />
  </React.Fragment>,
  'Devportal'
);
